import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/app/providers";
import { AppErrorBoundary } from "@/components/feedback";

import App from "./App.tsx";
import "./styles/globals.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root não encontrado em index.html.");
}

createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
);
